import { getCurrentISOStringWithTimezone } from "@simurgh/feathers/lib/date";
import { createModel, type Deck, type DeckIdentifiable } from "../model";
import { getRecordById } from "./read";
import { getTable } from "./shared";
import { database } from ":shared/database/connection";

export async function updateRecord(
	id: DeckIdentifiable["id"],
	data: Partial<Deck>,
): Promise<DeckIdentifiable> {
	const now = getCurrentISOStringWithTimezone();
	const record = await getRecordById(id);

	if (!record) {
		throw new Error(`Record with id ${id} not found`);
	}

	const {
		id: _id,
		createdAt,
		updatedAt,
		...rest
	} = {
		...record,
		...data,
		updatedAt: now,
	};
	const parsedData = createModel(rest as Deck);
	const updateData = {
		...parsedData,
		id: _id,
		createdAt,
		updatedAt,
	};

	await database.transaction("rw", getTable(), async () => {
		await getTable().update(id, updateData);
	});

	return updateData;
}
